import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="financial-breakdown-summation"
export default class FinancialBreakdownSummation extends Controller {
  static targets = ['amountInput', 'equityInput', 'amountSum']

  amountSumTargetConnected(target) {
    target.textContent = this.#sumTargetsValues(this.amountInputTargets);
  }

  // Actions
  sum(e) {
    const fieldName = e.currentTarget.dataset.field;

    const summationField = this.targets.findTarget(`${fieldName}Sum`);
    const inputFields = this.targets.findAllTargets(`${fieldName}Input`);

    summationField.textContent = this.#sumTargetsValues(inputFields);
  }

  // Private Methods
  #sumTargetsValues(targets){
    return targets.reduce((partialSum, element) => {
      if (!element.value || element.value.trim() === '') return partialSum;

      return partialSum + parseFloat(element.value);
    }, 0);
  }
}
